import type { ComboboxItemGroup } from '@any-ui-react/core';
import type { ComboboxItemWithFormatted } from '@/common/components/shared/select/props';

export const isGroup = (item: unknown): item is ComboboxItemGroup =>
  typeof item === 'object' && item !== null && 'group' in item && 'items' in item;

export function findInData<TData extends ComboboxItemWithFormatted>(data: TData[], value: string): TData | undefined {
  for (const item of data) {
    if (isGroup(item)) {
      for (const sub of (item as unknown as ComboboxItemGroup).items) {
        if (typeof sub !== 'string' && sub.value === value) return sub as unknown as TData;
      }
    } else if (item.value === value) {
      return item;
    }
  }
  return undefined;
}
